import { render } from "./DictionaryDynamic.vue?vue&type=template&id=39a48db8&scoped=true"
import script from "./DictionaryDynamic.vue?vue&type=script&lang=js"
export * from "./DictionaryDynamic.vue?vue&type=script&lang=js"

import "./DictionaryDynamic.vue?vue&type=style&index=0&id=39a48db8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a48db8"],['__file',"src/views/h5/common/basedata/dictionary/DictionaryDynamic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39a48db8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39a48db8', __exports__)) {
    api.reload('39a48db8', __exports__)
  }
  
  module.hot.accept("./DictionaryDynamic.vue?vue&type=template&id=39a48db8&scoped=true", () => {
    api.rerender('39a48db8', render)
  })

}


export default __exports__